import React, { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    document.title = "About Us - 10E Beauty";
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-[#5c2f2f]">
      <h1 className="text-3xl font-bold mb-6 text-[#a25d5d]">About Us</h1>

      <p className="mb-4 text-lg leading-relaxed">
        Welcome to <strong>10E Beauty</strong> – your go-to destination for curated beauty products. We believe in embracing the glow from within and offering high-quality brands that match your lifestyle and values.
      </p>

      <p className="mb-4 text-lg leading-relaxed">
        Our mission is to provide you with a seamless and delightful shopping experience. We hand-pick products from trusted and innovative brands to help you feel confident, beautiful, and empowered.
      </p>

      <p className="text-lg leading-relaxed">
        Thank you for being part of our journey. Whether you're looking for skincare, haircare, makeup, or more – we're here for you.
      </p>
    </div>
  );
};

export default AboutUs;
